import React from 'react';
import { motion } from 'framer-motion';
import { Button, Placeholder } from './ui';
export function FinalCTA() {
  return <section className="relative py-32 overflow-hidden" data-id="element-175">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-176">
        <Placeholder type="video" aspectRatio="auto" label="Underwater Background" className="rounded-none border-none" data-id="element-177" />
        <div className="absolute inset-0 bg-noronha-volcanic/90 bg-gradient-to-b from-noronha-volcanic via-noronha-volcanic/70 to-noronha-volcanic" data-id="element-178" />
      </div>

      <div className="container relative z-10 mx-auto px-6 text-center" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-180">
          <span className="font-mono text-sm tracking-widest text-noronha-gold uppercase mb-6 block" data-id="element-181">
            El océano te espera
          </span>
          <h2 className="text-5xl md:text-7xl font-heading font-medium text-noronha-text-heading mb-10" data-id="element-182">
            Nos vemos bajo el agua.
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-183">
            <Button variant="primary" className="w-full sm:w-auto px-8 py-4 text-base" data-id="element-184">
              Reservar mi lugar
            </Button>
            <Button variant="outline" className="w-full sm:w-auto px-8 py-4 text-base" data-id="element-185">
              Consultar disponibilidad
            </Button>
          </div>

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-noronha-graphite/50 backdrop-blur-sm border border-noronha-petroleum/50" data-id="element-186">
            <span className="w-2 h-2 rounded-full bg-noronha-emerald animate-pulse" data-id="element-187" />
            <span className="font-mono text-xs tracking-widest text-noronha-text-body uppercase" data-id="element-188">
              12 lugares disponibles
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}